<template>
  <div class="offer" :class="{ active: values.offer === offer.id }">
    <button type="button" class="offer__info" @click="doModal">
      <i class="vn-icons vn-icons-question-mark"></i>
    </button>
    <div class="offer__wrapper" @click="handleClick(offer.id, offer.name)">
      <div class="offer__head">
        <span class="offer__title">{{ offer.name }}</span>
      </div>
      <span class="offer__subtitle">{{ offer.subtitle }}</span>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="offer__excerpt" v-html="offer.excerpt"></div>
    </div>

    <div
      v-show="showModal"
      ref="modal"
      class="offer-modal"
      @click.self="closeModal"
    >
      <div class="offer-modal__body" @click.self="closeModal">
        <div class="container">
          <button type="button" class="offer-modal__close" @click="closeModal">
            <i class="vn-icons vn-icons-close"></i>
          </button>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="entry-content" v-html="modalContent"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'
import { Tooltip } from 'bootstrap'

export default {
  name: 'OfferItem',
  props: {
    offer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      modalContent: '',
    }
  },
  computed: {
    ...mapWritableState(useStagesStore, ['ajaxLoading', 'values']),
  },
  methods: {
    async doModal() {
      await $.ajax({
        url: this.vals.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
          id: this.offer.id,
          _ajax_nonce: this.vals.nonce,
          action: 'vn_get_devis_offer_modal',
        },
        beforeSend: () => {
          this.ajaxLoading = true
        },
        success: (res) => {
          this.modalContent = res.data.content
          this.showModal = true
          this.ajaxLoading = false

          this.$nextTick(() => {
            const tooltip = this.$refs.modal.querySelector(
              '[data-bs-toggle="tooltip"]'
            )

            tooltip &&
              new Tooltip(
                this.$refs.modal.querySelector('[data-bs-toggle="tooltip"]')
              )
          })

          $('body').css('overflow', 'hidden')
        },
      })
    },
    closeModal() {
      this.showModal = false
      $('body').css('overflow', '')
    },
    handleClick(id, name) {
      if (this.values.offer === id) {
        this.values.offer = null
        return
      }

      this.values.offer = id
      this.values.offerName = name
    },
  },
}
</script>

<style scoped lang="scss">
.offer {
  $this: &;

  display: flex;
  align-items: stretch;
  position: relative;

  &.active {
    #{$this}__wrapper {
      background-color: var(--vn-secondary-color);
      color: #fff;
    }

    #{$this}__info {
      color: #fff;
    }
  }

  &__wrapper {
    padding: 20px;
    background-color: #fff;
    cursor: pointer;
    transition: 250ms;
    width: 100%;

    &:hover {
      background-color: $gray-100;
    }
  }

  &__head {
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 30px;
    min-height: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    display: block;
  }

  &__subtitle {
    font-weight: 700;
    display: block;
    margin: 0 0 30px;
  }

  &__info {
    @include reset-btn;
    width: 24px;
    height: 24px;
    color: var(--vn-secondary-color);
    font-size: 24px;
    position: absolute;
    top: 20px;
    right: 20px;
    transition: 250ms;
  }
}

.offer-modal {
  position: fixed;
  top: var(--wp-adminbar-height);
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgba(#000, 0.75);
  z-index: 100;

  &__body {
    position: relative;
    z-index: 20;
    width: 100%;
    padding-top: 60px;
    margin-top: 100px;
    margin-bottom: 100px;

    @include media-breakpoint-down(lg) {
      margin-top: 50px;
    }

    .container {
      position: relative;
    }
  }

  .entry-content {
    background-color: #fff;

    @include media-breakpoint-down(sm) {
      padding-top: 30px;
    }
  }

  &__close {
    @include reset-btn;
    position: absolute;
    right: 12px;
    top: -60px;
    width: 140px;
    height: 60px;
    background-color: var(--vn-secondary-color);
    color: #fff;
    font-size: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
